export interface GkashFormPayload {
  url: string;
  fields: Record<string, string>;
}

/** POST a signed field set to the Gkash payment page (browser redirect). */
export function submitGkashPaymentForm(form: GkashFormPayload): void {
  const formEl = document.createElement("form");
  formEl.method = "POST";
  formEl.action = form.url;
  formEl.enctype = "application/x-www-form-urlencoded";
  formEl.style.display = "none";
  formEl.acceptCharset = "UTF-8";
  for (const [name, value] of Object.entries(form.fields)) {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    formEl.appendChild(input);
  }
  document.body.appendChild(formEl);
  formEl.submit();
}

/** Open Stripe redirect or auto-submit Gkash. Returns true when the browser is leaving for the gateway. */
export function openPaymentGateway(res: {
  status: string;
  redirectUrl?: string;
  form?: GkashFormPayload | string;
}): boolean {
  if (res.status === "REDIRECT" && res.redirectUrl) {
    window.location.href = res.redirectUrl;
    return true;
  }
  if (res.status === "GKASH_FORM" && res.form) {
    if (typeof res.form === "string") {
      const div = document.createElement("div");
      div.style.display = "none";
      div.innerHTML = res.form;
      document.body.appendChild(div);
      const el = div.querySelector("form");
      if (!el) return false;
      el.submit();
      return true;
    }
    if (res.form.url && res.form.fields) {
      submitGkashPaymentForm(res.form);
      return true;
    }
    return false;
  }
  return false;
}
